export enum FeatureType {
  Quantity = 'Quantity',
  Switch = 'Switch',
}
